import { Button } from "@/components/ui/button";
import { PropertyBasicInfo } from "./property-form/PropertyBasicInfo";
import { PropertyTypeSelect } from "./property-form/PropertyTypeSelect";
import { PropertyPricing } from "./property-form/PropertyPricing";
import { PropertySpecs } from "./property-form/PropertySpecs";
import { PropertyDescription } from "./property-form/PropertyDescription";

interface PropertyInfoProps {
  propertyTitle: string;
  propertyAddress: string;
  propertyType: string;
  salePrice: string;
  rentPrice: string;
  seasonalPrice: string;
  bedrooms: string;
  bathrooms: string;
  area: string;
  landArea: string;
  description: string;
  setPropertyTitle: (value: string) => void;
  setPropertyAddress: (value: string) => void;
  setPropertyType: (value: string) => void;
  setSalePrice: (value: string) => void;
  setRentPrice: (value: string) => void;
  setSeasonalPrice: (value: string) => void;
  setBedrooms: (value: string) => void;
  setBathrooms: (value: string) => void;
  setArea: (value: string) => void;
  setLandArea: (value: string) => void;
  setDescription: (value: string) => void;
  onSubmit?: (data: any) => Promise<void>;
}

export function PropertyInfoForm({
  propertyTitle,
  propertyAddress,
  propertyType,
  salePrice,
  rentPrice,
  seasonalPrice,
  bedrooms,
  bathrooms,
  area,
  landArea,
  description,
  setPropertyTitle,
  setPropertyAddress,
  setPropertyType,
  setSalePrice,
  setRentPrice,
  setSeasonalPrice,
  setBedrooms,
  setBathrooms,
  setArea,
  setLandArea,
  setDescription,
  onSubmit
}: PropertyInfoProps) {
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (onSubmit) {
      await onSubmit({
        propertyTitle,
        propertyAddress,
        propertyType,
        salePrice,
        rentPrice,
        seasonalPrice,
        bedrooms,
        bathrooms,
        area,
        landArea,
        description
      });
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <h3 className="text-lg font-semibold">Informações do Imóvel</h3>
      
      <PropertyBasicInfo
        propertyTitle={propertyTitle}
        propertyAddress={propertyAddress}
        setPropertyTitle={setPropertyTitle}
        setPropertyAddress={setPropertyAddress}
      />

      <PropertyTypeSelect
        propertyType={propertyType}
        setPropertyType={setPropertyType}
      />

      <PropertyPricing
        propertyType={propertyType}
        salePrice={salePrice}
        rentPrice={rentPrice}
        seasonalPrice={seasonalPrice}
        setSalePrice={setSalePrice}
        setRentPrice={setRentPrice}
        setSeasonalPrice={setSeasonalPrice}
      />

      <PropertySpecs
        bedrooms={bedrooms}
        bathrooms={bathrooms}
        area={area}
        landArea={landArea}
        setBedrooms={setBedrooms}
        setBathrooms={setBathrooms}
        setArea={setArea}
        setLandArea={setLandArea}
      />

      <PropertyDescription
        description={description}
        setDescription={setDescription}
      />

      <Button type="submit" className="w-full">
        Salvar
      </Button>
    </form>
  );
}